module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper",
    class: {
      'list-mode': _vm.convert
    },
    attrs: {
      "id": _vm.listId
    }
  }, [_c('header', [_c('a', {
    staticClass: "hide-list",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.convert = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th"
  })]), _vm._v(" "), _c('a', {
    staticClass: "show-list",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.convert = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th-list"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.datasets), function(item) {
    return _c('div', {
      staticClass: "box"
    }, [_c(_vm.convertModuleToComp(item.module), {
      directives: [{
        name: "drag",
        rawName: "v-drag"
      }, {
        name: "tag",
        rawName: "v-tag",
        value: (_vm.productModuleConf(item.module)),
        expression: "productModuleConf(item.module)"
      }],
      tag: "div",
      staticClass: "move"
    }), _vm._v(" "), (_vm.convert) ? _c('Introduction', {
      attrs: {
        "content": item
      }
    }) : _vm._e()], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-70d0251a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = 71
// module chunks = 0